import { render, staticRenderFns } from "./BindPhonePopup.vue?vue&type=template&id=d64b676e&scoped=true"
import script from "./BindPhonePopup.vue?vue&type=script&lang=ts"
export * from "./BindPhonePopup.vue?vue&type=script&lang=ts"
import style0 from "./BindPhonePopup.vue?vue&type=style&index=0&id=d64b676e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64b676e",
  null
  
)

export default component.exports